var React = require('react');

function Azbel (props) {
    return React.createElement("svg",props,[React.createElement("defs",{"key":0},React.createElement("style",null,".cls-1{fill:none;stroke:#000;stroke-linecap:square;stroke-linejoin:bevel;stroke-width:2px;}")),React.createElement("title",{"key":1},"Azbel"),React.createElement("g",{"id":"g1478","key":2},[React.createElement("path",{"id":"path1650-2","className":"cls-1","d":"M14,99H24V89h80V99h10V29H104V39H24V29H14Z","key":0}),React.createElement("path",{"id":"path1652-6-9","className":"cls-1","d":"M64,39V9","key":1}),React.createElement("path",{"id":"path1652-2-7","className":"cls-1","d":"M64,119V89","key":2})])]);
}

Azbel.defaultProps = {"id":"svg8","viewBox":"0 0 128 128"};

module.exports = Azbel;

Azbel.default = Azbel;
